import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TipoProfissionalService {
  private data = null;
	private url = environment.serviceApi;
  constructor(public http: Http) { }

  	getTiposProfissional(ordem=null) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/tiposprofissional' + (ordem? '/ordem/' + ordem : ''))
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	getTipoProfissional(id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/tiposprofissional/' + id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	criaTipoProfissional(data) {
		return new Promise((resolve, reject) => {
			this.http.post(this.url + '/tiposprofissional', {
				tipo_profissional_nome: data.tipo_profissional_nome
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	editaTipoProfissional(data) {
		return new Promise((resolve, reject) => {
			this.http.put(this.url + '/tiposprofissional/' + data.tipo_multa_id, {
				tipo_profissional_nome: data.tipo_profissional_nome
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	apagaTipoProfissional(id) {
		return new Promise((resolve, reject) => {
			this.http.delete(this.url + '/tiposprofissional/' + id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}
}
